import React, {useState} from "react";
import {Panel} from 'primereact/panel';
import {Divider} from 'primereact/divider';
import FileUploader from "../../../components/fileUploader/FileUploader";
import FileService from "../../../service/FileService";
import GeneralUtils from "../../../utils/GeneralUtils";
import Loading from "../../../components/loading/Loading";

const Overview = (props) => {
    const {course, imageSrc, imageFile, setImageFile, videoFile, setVideoFile} = props;
    const [loading, setLoading] = useState(false);
    const fileService = new FileService();

    const onUpload = (file) => {
        if(file){
            setLoading(true);
            fileService.upload(getImageForm(file)).then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && (GeneralUtils.isNullOrEmpty(response.type) || response.type === "SUCCESS")
                    && GeneralUtils.isNullOrEmpty(response.error)){
                    setImageFile(file);
                }
                setLoading(false);
            });
        }
    }

    const getImageForm = (imageFile) => {
        const imageForm = new FormData();
        imageForm.append('file', imageFile);
        imageForm.append('name', imageFile.name);
        imageForm.append('path', "course");
        imageForm.append('id', course.id);
        return imageForm;
    }

    return (
        <Panel header="Kurs Tanıtımı">
            <Divider><label className="font-bold">Kurs Görüntüsü</label></Divider>
            <div className="flex flex-row gap-2">
                <FileUploader type="image" name="image" accept=".gif,.jpg,.jpeg,.png,.webp" src={imageSrc}
                              onUpload={file => onUpload(file)} file={imageFile}
                              label="Kurs görüntünüzü buraya yükleyin. Görüntünün kabul edilmesi için kurs görüntüsü kalite standartlarımızı karşılaması gerekir.
                    Önemli yönergeler: 750x422 piksel; .jpg, .jpeg, .gif, .png veya .webp. Ayrıca görüntü, metin içermemelidir."/>
            </div>

            {/*<Divider> <label className="font-bold">Kurs Tanıtım Videosu</label></Divider>*/}
            {/*<div className="flex flex-row gap-2">*/}
            {/*    <FileUploader type="video" name="video"*/}
            {/*                  accept=".avi,.mpg,.mpeg,.flv,.mov,.m2v,.m4v,.mp4,.rm,.ram,.vob,.ogv,.webm,.wmv"*/}
            {/*                  onUpload={file => setVideoFile(file)} file={videoFile}*/}
            {/*                  label="Tanıtım videonuz, öğrencilerin kursunuzda neler öğreneceklerini ön izlemesini sağlayan hızlı ve ilgi çekici bir yöntemdir.*/}
            {/*            İyi hazırlanmış bir tanıtım videonuz varsa kursunuza katılmayı düşünen öğrencilerin kursa kaydolması daha olasıdır."/>*/}
            {/*</div>*/}
            {loading && <Loading/>}
        </Panel>
    )
};

export default Overview;
